const faqs = [
  {
    q: '快看影视是否需要注册会员？',
    a: '完全不需要。快看影视所有电视剧资源均可免费在线观看，无需注册、无需登录，打开网站即可直接播放，真正做到零门槛追剧体验。',
  },
  {
    q: '播放时出现卡顿或缓冲怎么办？',
    a: '快看影视采用智能CDN加速技术，覆盖全国多节点服务器。如遇卡顿可尝试切换清晰度或刷新页面，建议使用Chrome等现代浏览器获得最佳体验。',
  },
  {
    q: '电视剧资源多久更新一次？',
    a: '我们每日同步全网最新剧集资源，热门在播剧集通常在播出后2小时内上线，完结剧集亦持续补全高清版本，确保追剧党不错过任何精彩内容。',
  },
  {
    q: '支持哪些设备观看？画质如何？',
    a: '快看影视完美适配电脑、手机、平板等全终端设备，默认提供1080P高清画质，部分热门剧集支持蓝光级清晰度，带给你沉浸式观影享受。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          常见问题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          追剧无忧，快速了解快看影视
        </p>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-semibold text-foreground-900">
                {faq.q}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}